class CartNotification
  constructor: (@okTitle, @okText, @noSizeText, @errorText) ->

  note: (title, text, type)->
    new PNotify
      title: title
      text: text
      type: type

  added: -> @note @okTitle, @okText, "success"
  noSize: -> @note @errorText, @noSizeText, 'error'
  ok: (text) -> @note @okTitle, text, 'success'
  error: (text) ->
    if Array.isArray(text) && text.length > 1
      text = '- ' + text.join('\n- ')
    @note @errorText, text, 'error'